import { Checkbox } from '@vechaiui/react';
import { Field } from 'formik';
import { Link } from 'react-router-dom';
import { Localized, useLocalization } from '@fluent/react';

import { InputFormik } from '#/components/controls/Input';
import { PublicRoute } from '#/constants/page-route';

const LoginForm: React.FC<LoginFormProps> = () => {
  const { l10n } = useLocalization();

  return (
    <div className="space-y-6">
      <Localized id="username" attrs={{ placeholder: true }}>
        <InputFormik label={l10n.getString('username')} name="username" type="text" />
      </Localized>

      <Localized id="password" attrs={{ placeholder: true }}>
        <InputFormik label={l10n.getString('password')} name="password" type="password" />
      </Localized>

      <div className="flex items-center justify-between">
        <Field as={Checkbox} size="lg" name="rememberMe">
          {l10n.getString('remember-me')}
        </Field>

        <Link className="underline underline-offset-2" to={PublicRoute.RequestPasswordReset}>
          {l10n.getString('forgot-password')}
        </Link>
      </div>
    </div>
  );
};
export type LoginFormProps = {};

export default LoginForm;
